import { ProductListItem } from './product';
import { RequestStatus } from './request';
import { UserPreview } from './user';
import { OrganizationListItem } from './organization';

export enum OrderStatus {
    OrderForming = 'order_forming',
    OrderReject = 'order_reject',
    OnPayment = 'on_payment',
    Completed = 'completed',
}

export interface OrderRequest {
    id: number;
    quantity: number;
    companyId: number;
    initiator: UserPreview;
    status: RequestStatus;
    comment: string | null;
    createdAt: string;
    updatedAt: string;
    user: UserPreview;
}

export interface OrderListItem {
    id: number;
    status: OrderStatus;
    productPrice: number | null;
    comment: string | null;
    initiator: UserPreview;
    createdAt: string;
    updatedAt: string;
    requests: OrderRequest[];
    updatedLogin: string;
    product: ProductListItem;
    bik: string | null;
    bankName: string | null;
    bankAccountNumber: string | null;
    correspondentNumber: string | null;
    contactFirstName: string | null;
    contactMiddleName: string | null;
    contactLastName: string | null;
    contactPhone: string | null;
    contactEmail: string | null;
    company: OrganizationListItem;
}

export type OrderItem = OrderListItem;
